module.exports = __webpack_public_path__ + "static/media/pumpkin.a4330c28.svg";